import React from 'react'
import withProps from 'recompose/withProps'
import styled from 'react-emotion'
import { mediumMediaQuery } from 'utils/style-helpers'
import Link from 'gatsby-link'
import logo from './logo.png'

const Container = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
`

const Logo = withProps({
  src: logo,
  alt: 'ChouxBox'
})(styled.img`
  display: inline-block;
  margin: 0 15px 20px;

  ${mediumMediaQuery} {
    margin: 0 30px 0 0;
  }
`)

const Misc = styled.div`
  margin: 0 15px 20px;
  text-align: center;

  ${mediumMediaQuery} {
    margin: 0;
    text-align: left;
  }
`

const Copyright = styled.p`
  color: #dedede;
  font-size: 14px;
  margin: 0;
`

const Links = styled.ul`
  margin: 8px 0 0 0;
  line-height: 12px;

  li {
    display: inline-block;
    margin: 0;
    padding: 0 5px;
    border-left: 1px solid #4caf50;
    color: #4CAF50;
    font-size: 12px;

    &:first-child {
      padding-left: 0;
      border-left: 0;
    }

    a {
      color: inherit;
      text-decoration: none;
    }
  }
`

const Info = () => (
  <Container>
    <Logo />
    <Misc>
      <Copyright>&copy; 2021 ChouxBox. All rights reserved</Copyright>
      <Links>
        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
        <li><Link to="/terms-of-service">Terms of Service</Link></li>
      </Links>
    </Misc>
  </Container>
)

export default Info



// WEBPACK FOOTER //
// ./src/components/Footer/Info/index.js